import React from "react";

const Label = ({ label, fontSize, height, padding, margin, color, fontWeight, fontStyle, textAlign, style, className, onClick }) => {
    return (
        <label 
            className={className}
            onClick={onClick}
            style={{ 
                margin, 
                padding, 
                height, 
                fontFamily: "Helvetica", 
                fontSize, 
                fontStyle,
                color, 
                fontWeight, 
                textAlign,
                ...style  // Spread additional style props
            }}
        >
            {label}
        </label>
    );
};

export default Label;

